// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__1ria3","search":"Settings_search__3t3Fb","filter":"Settings_filter__1pAXg"};